import { NgOptimizedImage } from '@angular/common';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngrx/store';
import { AuthService } from '@services/auth/auth.service';
import { QtyLabelModule } from '@shared/components/qty-label/qty-label.module';
import { BackdropModule } from '@shared/components/UI/backdrop/backdrop.module';
import { CheckPermissionsModule } from '@shared/directives/check-permissions/check-permissions.module';
import { initApplication } from '@shared/initApplication/initApplication';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidebarComponent } from './components/sidebar/sidebar/sidebar.component';
import { TechnicalWorkComponent } from './containers/technical-work/technical-work.component';
import { CoreModule } from './core/core.module';
import { AttentionEdspListComponent } from './profile/components/attention-esdp-list-component/attention-esdp-list-component';
import { SharedModule } from '@shared/shared.module';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomMatPaginatorIntl } from '@shared/adapter/mat-paginator.adapter';

@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    TechnicalWorkComponent,
    AttentionEdspListComponent,
  ],
  imports: [
    FontAwesomeModule,
    AppRoutingModule,
    MatDialogModule,
    CheckPermissionsModule,
    CoreModule,
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    MatIconModule,
    MatTooltipModule,
    MatDividerModule,
    MatMenuModule,
    MatCheckboxModule,
    BackdropModule,
    QtyLabelModule,
    NgOptimizedImage,
    SharedModule,
    MatCardModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'ru' },
    {
      provide: APP_INITIALIZER,
      useFactory: initApplication,
      multi: true,
      deps: [Store, AuthService],
    },
    {
      provide: MatPaginatorIntl,
      useClass: CustomMatPaginatorIntl,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
